import React from 'react';
import styled from 'styled-components';
import DownloadButton from '../DownloadButton';
import * as Icons from '../Icons';
export const SingleFileSectionStyle = styled.div `
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin: 0;
  margin-top: 15px;

  &:first-child {
    margin-top: 0px;
  }
`;
export const TitleStyle = styled.p `
  margin: 0;
  padding-left: ${(props) => (props.isEnterprise ? '7px' : '15px')}
  font-size: ${(props) => props.theme.fontSmall};
  color: ${(props) => props.theme.navyBlue};
  word-break: break-all;
  padding-right: 15px;
`;
const TitleStyleLink = styled.a `
  margin: 0;
  padding-left: ${(props) => (props.isEnterprise ? '7px' : '15px')};
  font-size: ${(props) => props.theme.fontSmall};
  color: ${(props) => props.theme.navyBlue};
  word-break: break-all;
  padding-right: 15px;
`;
export const TextWrapper = styled.div `
  display: flex;
  align-items: center;
`;
export const DownloadIconBox = styled.div `
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
`;
const SingleFileSection = ({ file, downloadProps, fileIcon, text, isEnterprise, }) => (React.createElement(SingleFileSectionStyle, { className: "single-file-section" },
    React.createElement(TextWrapper, null,
        (fileIcon && isEnterprise) || React.createElement(Icons.FileDefault, null),
        React.createElement(TitleStyleLink, { className: "file-title", href: file.url, isEnterprise: isEnterprise }, file.filename)),
    isEnterprise || (React.createElement(DownloadIconBox, null,
        React.createElement(DownloadButton, Object.assign({ size: "Small", external: true, url: file.url, text: text }, downloadProps))))));
export default SingleFileSection;
